import axios from "../axios";
import { parseResponse } from "./../responseHandling/delete";

export async function signOut() {
  try {
    const res = await axios.delete("/users/sign_out");
    return parseResponse(res);
  } catch (error) {
    throw error 
  }
}
